import { render, staticRenderFns } from "./Collapse.vue?vue&type=template&id=0fe041d6&scoped=true&"
import script from "./Collapse.vue?vue&type=script&lang=ts&"
export * from "./Collapse.vue?vue&type=script&lang=ts&"
import style0 from "./Collapse.vue?vue&type=style&index=0&id=0fe041d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe041d6",
  null
  
)

export default component.exports